// Web mirror of the server source registry: map a page's agent entity to a
// correspondence target (source, sourceId). Pages with a URL-derived entity
// (customer, project) get correspondence for free; others register explicitly
// via useCorrespondenceTarget.
import type { AgentPageContext } from "../agent/AgentProvider";

export interface CorrespondenceTarget {
  source: string;
  sourceId: string;
  label?: string;
}

// agent entity.type → correspondence source. Identity for most; alias here if they
// ever diverge.
const ENTITY_TO_SOURCE: Record<string, string> = {
  customer: "customer",
  project: "project",
  person: "person",
  visit: "visit",
  ticket: "ticket",
};

/** Derive a correspondence target from the agent's page context, or null. */
export function targetFromContext(ctx: AgentPageContext | null): CorrespondenceTarget | null {
  const e = ctx?.entity;
  if (!e) return null;
  const source = ENTITY_TO_SOURCE[e.type];
  if (!source) return null;
  return { source, sourceId: e.id, label: e.name };
}
